
import { Component, Vue } from 'vue-property-decorator'
import BasicImage from '@mg/web-components/Atoms/Image/BasicImage'
import {
  googleAnalytics,
  GtmComponentType,
} from '@mg/web-components/directives/googleAnalytics'
import { getImageUrl } from '@mg/web-components/utils/image'
import { GET_PAGE_BANNERS, GetPageBannersQuery } from '~/graphql/gql/banners'
import {
  GQLPageBanners,
  GQLUpperRightCornerBanner,
} from '~/graphql/__generated__/interfaces'
import ApolloFetchPolicies from '~/utils/apolloFetchPolicies'

@Component<TheUpperRightCornerBanner>({
  apollo: {
    getPageBanners: {
      fetchPolicy: ApolloFetchPolicies.CACHE_ONLY,
      query: GET_PAGE_BANNERS,
      variables(): GetPageBannersQuery {
        const pageUrl = this.$route.path
        return {
          pageUrl,
        }
      },
    },
  },
  components: { BasicImage },
  directives: { googleAnalytics },
})
export default class TheUpperRightCornerBanner extends Vue {
  getPageBanners!: GQLPageBanners

  get slide(): GQLUpperRightCornerBanner | null | undefined {
    return this.getPageBanners?.upperRightCornerBanner
  }

  get imgSrc() {
    return getImageUrl(Number(this.slide?.mediaId), { height: 60, width: 300 })
  }

  getGaData(slide: GQLUpperRightCornerBanner) {
    const { bannerId, slideId, gaTag } = slide
    const { pageId } = this.getPageBanners
    return {
      componentType: GtmComponentType.BANNER,
      data: {
        banner: {
          bannerId,
          bannerType: 'UpperRightCornerBanner',
          gaTag,
          pageId,
        },
        slideId,
        slidePosition: 1,
      },
      router: this.$route.path,
    }
  }
}
